<div id="{{id}}" class="{{#if hideCriteriaFirstTime}}hidden{{/if}}">
    <field-item item="criteriaFormModel">
        <field-hcombo id="criteria-selectByType" name="type" label="" {options}="typeOptions"></field-hcombo>

        <field-radios label="" name="action" {options}="actions" {visible}="states.action"></field-radios>

    </field-item>
</div>
